const reportCallbackError = (eventName, errorReporter) => e => {
  errorReporter(`An error occurred in one of ${eventName} callbacks`, e)
}

module.exports = reportCallbackError



// WEBPACK FOOTER //
// ./logger/error-boundaries/reportCallbackError.js